module.exports = __webpack_public_path__ + "static/media/SE-UC-GD006_v6-Responsibility-Matrix-Guide-2.c068f2de.png";